import { render, staticRenderFns } from "./Attendances.vue?vue&type=template&id=1175731c&scoped=true&"
import script from "./Attendances.vue?vue&type=script&lang=js&"
export * from "./Attendances.vue?vue&type=script&lang=js&"
import style0 from "./Attendances.vue?vue&type=style&index=0&id=1175731c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175731c",
  null
  
)

export default component.exports